<ion-button color="danger" class="sos-btn" [class.offline]="!isOnline()" (click)="openSOS()">
  <span class="sos-inner">SOS</span>
</ion-button>
